import styled from 'styled-components';

// TODO: `components` should not import from `pages`.
import { ChevronDownIcon } from '@app/pages/Prototype/icons';

import { Typography } from '../DesignSystem';

const CHEVRON_WIDTH = 30;

export const CreateYatButtonWrapper = styled.div`
    padding: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: radial-gradient(39.62% 142.82% at 67.14% 50.58%, #3a3367 0%, #181629 100%);
    backdrop-filter: blur(74px);
`;

export const MobileDropdownPanelTrigger = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: red;
    border-radius: 24px;
    overflow: hidden;
    background: #222030;
    display: inline-flex;
`;

export const ChevronWrapper = styled.div`
    display: flex;
    width: ${CHEVRON_WIDTH}px;
    align-items: center;
    justify-content: center;
`;

export const Chevron = styled(ChevronDownIcon)`
    width: 10px;
    height: 4px;
    fill: transparent !important;
`;

export const YatPickerLabel = styled(Typography)`
    margin: 20px 30px 0 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
`;

export const NoYatElement = styled.div`
    white-space: nowrap;
    display: flex;
    align-items: center;
    margin: 4px -4px 4px 4px;
    padding: 6px 15px;
    height: 36px;
    border-radius: 50px;
    font-weight: 600;
    letter-spacing: -0.03em;
    background: linear-gradient(180deg, #3f3b58 0%, #221a25 100%);
`;

export const ChipMemberWrapper = styled.div`
    margin-right: -4px;
    border: 2px solid transparent !important;

    > span {
        cursor: pointer;
    }
`;
